import type { FaireProductEntity } from "../../entity_types/product";

export const p_serkxkjcxh: FaireProductEntity = {
  token: "p_serkxkjcxh",
  type: "product",
  name: "Little Notes® Envelopes - Spruce",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4ebb58438da4ec5e9eaa2db5216dc64f1677b31507f1861602a39ace022a17ed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6845e17dc6818909980da81d0f3735bf79f93b5ab0a2ecf3fc22aac2a22ec388.jpeg",
    "https://cdn.faire.com/fastly/a0f76f31930cecfa135035d6ab6ddd66b7c071e6f02677057772a4870c451408.jpeg",
    "https://cdn.faire.com/fastly/31b4b5be7edd8d477995bbcd27c1eb96fdde1c14e36b3a6dbee0b1118155f9f0.jpeg",
    "https://cdn.faire.com/fastly/c9a1c145ca03f4a710c410326c474b64987a71ce18846dbdc9b3076135058c25.jpeg",
  ],
  priceDollars: 5,
  description:
    "Round out your Little Notes® collection with our Little Notes® Envelopes: a set of 20 tiny envelopes, each just the right size for a single Little Note. Perfect for a tip, a secret note, or to add a gummy bear to sweeten the love. These petite envelopes turn every Little Note into a secret surprise.\n\nPlease note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:01.432Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
